import { z } from 'zod';

export const headerStyleSchema = z.strictObject({
  container: z
    .strictObject({ color: z.string().optional(), backgroundColor: z.string().optional() })
    .optional(),
  ctaButton: z
    .strictObject({ color: z.string().optional(), backgroundColor: z.string().optional() })
    .optional(),
});
export const footerStyleSchema = z.strictObject({
  container: z
    .strictObject({ color: z.string().optional(), backgroundColor: z.string().optional() })
    .optional(),
});
export const sectionStyleSchema = z.strictObject({
  container: z
    .strictObject({
      color: z.string().optional(),
      backgroundColor: z.string().optional(),
      background: z.string().optional(),
      paddingBlock: z.string().optional(),
      alignItems: z.string().optional(),
    })
    .optional(),
});
export const columnStyleSchema = z.strictObject({
  container: z
    .strictObject({
      background: z.string().optional(),
      border: z.string().optional(),
      borderRadius: z.string().optional(),
      padding: z.string().optional(),
      gap: z.string().optional(),
      justifyContent: z.string().optional(),
      boxShadow: z.string().optional(),
    })
    .optional(),
});
const headingStyleSchema = z.strictObject({ fontSize: z.string().optional() });
export const markdownStyleSchema = z.strictObject({
  container: z
    .strictObject({
      color: z.string().optional(),
      textAlign: z.string().optional(),
      fontSize: z.string().optional(),
      maxWidth: z.string().optional(),
      marginInline: z.string().optional(),
    })
    .optional(),
  h1: headingStyleSchema.optional(),
  h2: headingStyleSchema.optional(),
  h3: headingStyleSchema.optional(),
  h4: headingStyleSchema.optional(),
  h5: headingStyleSchema.optional(),
  h6: headingStyleSchema.optional(),
});
export const imageStyleSchema = z.strictObject({
  image: z
    .strictObject({
      margin: z.string().optional(),
      width: z.string().optional(),
      height: z.string().optional(),
      objectFit: z.string().optional(),
    })
    .optional(),
  caption: z.strictObject({ color: z.string().optional() }).optional(),
});
export const iconStyleSchema = z.strictObject({
  container: z.strictObject({ textAlign: z.string().optional() }).optional(),
  icon: z
    .strictObject({
      color: z.string().optional(),
      background: z.string().optional(),
      borderRadius: z.string().optional(),
      padding: z.string().optional(),
    })
    .optional(),
});
export const formStyleSchema = z.strictObject({
  container: z.strictObject({ color: z.string().optional() }).optional(),
  submitButton: z
    .strictObject({ color: z.string().optional(), backgroundColor: z.string().optional() })
    .optional(),
});
export type ColumnStyle = z.infer<typeof columnStyleSchema>;
export type StyleProperties = {
  color?: string;
  backgroundColor?: string;
  textAlign?: string;
  fontSize?: string;
  margin?: string;
  width?: string;
  height?: string;
  objectFit?: string;
  paddingBlock?: string;
  alignItems?: string;
  maxWidth?: string;
  marginInline?: string;
} & NonNullable<ColumnStyle['container']>;
export type FormStyle = z.infer<typeof formStyleSchema>;
